import '.i{display:grid;}.ssr-plugin'
import '.x{gap:1rem;}.ssr-plugin'
import { styled } from 'inlines'
import Column from '@app/components/layout/Column'
import { ReactNode } from 'react'
import { Image } from '@app/components/core/image/Image'

export type ImageOveriewProps = {
  images: string[]
  header: ReactNode
  onImageClick: (index: number) => void
}

export const ImageOveriew = ({
  images,
  header,
  onImageClick,
}: ImageOveriewProps) => {
  return (
    <Column alignItems="stretch" style={{ padding: '2rem' }}>
      {header}
      <div className="i x"
        style={{
          gridTemplateColumns: `repeat(${images.length > 2 ? '3' : '2'}, 1fr)`,
          gridTemplateRows: `repeat(${Math.trunc(Math.ceil(images.length / 3))}, 1fr)`,}}
      >
        {images.map((image, index) => (
          <div>
            <Image
              onClick={() => onImageClick(index)}
              src={image}
              resizeWidth={1000}
              alt={`Overview. initiative image ${index}`}
              style={{
                width: '100%',
                height: '100%',
                aspectRatio: '1/1',
                objectFit: 'cover',
                borderRadius: '0.625rem',
                display: 'block',
              }}
            />
          </div>
        ))}
      </div>
    </Column>
  )
}
